import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Button from 'components/common/Button';
import Select from 'components/form/Select';
import TextField from 'components/form/Input';
import Form from 'components/form';
import withConfirm from 'hooks/withConfirm';
import { PRIORITY } from 'modules/admin/todos';

const FormItem = Form.FormItem;

const Task = ({ data, onSave, onDelete, role, trigger, confirm, form }) => {
  const { getFieldDecorator, validateFields, setFieldsValue } = form;

  useEffect(() => {
    if (data) {
      const parsed = JSON.parse(data.body);
      setFieldsValue(parsed);
    }
  }, []);

  const handleDelete = () => {
    confirm(() => onDelete(data.id));
  };

  const handleSave = () => {
    return validateFields().then((values) => {
      return onSave({
        id: data?.id,
        body: JSON.stringify(values),
        recipient_role: role,
        delivery_type: 'task',
        event_trigger: trigger,
      });
    });
  };

  return (
    <Box marginBottom={3}>
      <Card>
        <CardHeader
          title="Create Task"
          titleTypographyProps={{ variant: 'subtitle1' }}
        />
        <CardContent>
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {getFieldDecorator('title', {
                  rules: [{required: true }]
                })(<TextField label="Title" />)}
              </Grid>
              <Grid item md={4}>
                {getFieldDecorator('priority', {
                  rules: [{required: true }]
                })(
                  <Select
                    options={PRIORITY}
                    isMulti={false}
                    transformValue
                    label="Priority"
                  />,
                )}
              </Grid>
              <Grid item md={4}>
                {getFieldDecorator('due_days', {
                  normalize: (val) => +val,
                  rules: [{required: true }],
                })(
                  <TextField
                    label="Days until due" type="number" />,
                )}
              </Grid>
              <Grid item md={4}>
                {getFieldDecorator('reminder_days', {
                  normalize: (val) => +val,
                })(
                  <TextField
                    label="Days until reminder (optional)"
                    type="number"
                  />,
                )}
              </Grid>
              <Grid item xs={12}>
                {getFieldDecorator('notes')(
                  <TextField label="Note (optional)" />,
                )}
              </Grid>
            </Grid>
          </Form>
          <Box marginTop={2} display="flex" justifyContent="space-between">
            <Button color="primary" variant="contained" onClick={handleSave}>
              Save
            </Button>
            {data && (
              <Button color="secondary" onClick={handleDelete}>
                Delete
              </Button>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default withConfirm(Form.create()(Task));
